import {
  getStorage,
  setStorage,
  updateStorage,
} from '~/listenerEventService/Queue/storageController';

export interface IBufferItem {
  eventPath: string;
  eventTime: string;
  eventData: string;
  eventType: string;
  title: string;
  '@type': 'AnalyticsEvent';
}

export interface IQueue {
  buffer: IBufferItem[];
  clearBuffer: () => void;
  push: (items: IBufferItem) => number;
  getBuffer: () => IBufferItem[];
  unshift: (items: IBufferItem[]) => number;
}

class Queue implements IQueue {
  buffer: IBufferItem[];

  constructor() {
    this.buffer = [...getStorage()];
  }

  clearBuffer = () => {
    this.buffer = updateStorage([]);
  }

  push = (items: IBufferItem): number => {
    this.buffer = setStorage(items);

    return this.buffer.length;
  }

  getBuffer = (): IBufferItem[] => {
    const tempBuffer = [...this.buffer];
    this.clearBuffer();

    return tempBuffer;
  }

  unshift = (items: IBufferItem[]): number => {
    this.buffer.unshift(...items);

    return updateStorage(this.buffer).length;
  }
}

export default new Queue();
